// Analytics Tag Labels
export const PRODUCT_ADD_TO_CART_EVENT = "e_addToCart";
export const PRODUCT_ADD_TO_LIST_EVENT = "e_addToList";
export const PRODUCT_IMPRESSION_EVENT = "e_productImpressions";
export const ADDON_PRODUCT_IMPRESSION_EVENT = "e_addOnProductImpressions";
export const SEARCH_RESULTS_EVENT = "e_searchResults";
export const PRODUCT_CLICK_EVENT = "e_productClick";
export const PRODUCT_FIRST_ADD_TO_CART_EVENT = "e_firstAddToCart"; // once per product (using /add endpoint, quantity in the cart is 0)
export const FIRST_CLICK_EVENT = "e_searchResultInteraction"; // once per pageview, 1st interaction on the page, search pages only
export const PDP_CLICK_THROUGH_EVENT = "e_pdpClickThrough";
